import React, { useState, useRef, useContext } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import JoditEditor from "jodit-react";
import { RotatingSquare } from "react-loader-spinner";
import { AuthContext } from "../../../../Contexts/AuthContext/AuthProvider";

const NewCoinMessage = () => {
  const { authUser } = useContext(AuthContext);
  const DisRef = useRef(null);
  const [Dis, setDisContent] = useState("");
  const [errorMessage, setErrorMessage] = useState([]);
  const refSubmitDis = useRef();

  const handleSubmitData = (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    setErrorMessage("");
    const formData = new FormData(event.currentTarget);
    const InpuData = Object.fromEntries(formData);
    const storeData = { ...InpuData, dis: Dis };
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    axios
      .post(
        `https://api.wlfmobile.com/api/admin/new/coin/message/store`,
        storeData,
        config
      )
      .then((response) => {
        event.target.reset();
        toast.success(`${response?.data.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        refSubmitDis.current.removeAttribute("disabled");
      })
      .catch((error) => {
        refSubmitDis.current.removeAttribute("disabled");
        if (error?.response?.data?.errors) {
          setErrorMessage(error?.response?.data?.errors);
        } else {
          setErrorMessage(error?.response?.data);
        }
      });
  };

  if (!authUser?.new_coin) {
    if (authUser?.new_coin === undefined) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <h1>unauthorized</h1>
        </>
      );
    }
  } else {
    return (
      <>
        <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
          <h6 className="page-title">New Coin Message</h6>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 mb-30">
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmitData}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="heading" className="required">
                          Title
                        </label>
                        <textarea name="title" placeholder="Title"></textarea>
                        {errorMessage?.title && (
                          <span className="text-danger pt-2">
                            {errorMessage?.title?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="button_one_url" className="required">
                          Description
                        </label>
                        <JoditEditor
                          ref={DisRef}
                          value={Dis}
                          height="600"
                          onChange={(newContent) => setDisContent(newContent)}
                        />
                        {errorMessage?.dis && (
                          <span className="text-danger pt-2">
                            {errorMessage?.dis?.msg}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button
                      ref={refSubmitDis}
                      type="submit"
                      className="btn btn-primary w-100 h-45"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default NewCoinMessage;
